import Vue from "vue";
import { requiredValidator, Validator } from "../utils/validators";

interface IFormLike {
	registerInput(el:{validate():boolean}):void;
	deregisterInput(el:{validate():boolean}):void;
}

export const Validatable = Vue.extend({
	data() {
		return {
			isValid: false,
			validatorError: "",
			parentForm: null as null | IFormLike
		};
	},
	props: {
		required: Boolean,
		validators: {
			type: Array as () => Validator[],
		},
		// eslint-disable-next-line vue/require-prop-types
		value: {
		}
	},
	methods: {
		validate():boolean {
			this.isValid = true;
			this.validatorError = "";
			if (this.required) {
				let result = requiredValidator(this.value);
				if (!result) {
					this.isValid = false;
					return false;
				}
			}
			if (!this.validators) {
				return true;
			}
			for (let validator of this.validators) {
				let result = validator(this.value);
				if (result === false) {
					this.isValid = false;
					return false;
				}
				if (result !== true) {
					this.isValid = false;
					this.validatorError = result as string;
					return false;
				}
			}
			return true;
		}
	},
	created() {
		let el = this.$parent as any;
		while (el != null) {
			if (typeof(el.registerInput) == "function" && typeof(el.deregisterInput) == "function") {
				this.parentForm = el as IFormLike;
				this.parentForm.registerInput(this);
				el = null;
			} else {
				el = el.$parent;
			}
		}
	},
	destroyed() {
		if (this.parentForm) {
			this.parentForm.deregisterInput(this);
		}
	}
});